import { render, staticRenderFns } from "./HdsBtn.vue?vue&type=template&id=ee134222&scoped=true&"
import script from "./HdsBtn.vue?vue&type=script&lang=ts&"
export * from "./HdsBtn.vue?vue&type=script&lang=ts&"
import style0 from "./HdsBtn.vue?vue&type=style&index=0&id=ee134222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee134222",
  null
  
)

export default component.exports